export const CONTACT_US_STATE_KEY = 'contactUs'
export const FORM_CONTACT_US_NAME = 'fos_message_new_thread'

export const CONTACT_US_MESSAGE_SENT_SUCCESSFULLY = 'Casino/ContactUs/CONTACT_US_MESSAGE_SENT_SUCCESSFULLY'

export const CONTENT_LOAD = 'Casino/ContactUs/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/ContactUs/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/ContactUs/LOAD_ERROR'
